import 'vue-material-design-icons/styles.css'
import AccountCircleIcon from 'vue-material-design-icons/AccountCircle.vue'
import AlertCircleOutlineIcon from 'vue-material-design-icons/AlertCircleOutline.vue'
import AlertDecagramIcon from 'vue-material-design-icons/AlertDecagram.vue'
import AlertIcon from 'vue-material-design-icons/Alert.vue'
import ArrowCollapseDownIcon from 'vue-material-design-icons/ArrowCollapseDown.vue'
import ArrowLeftBoldCircleOutlineIcon from 'vue-material-design-icons/ArrowLeftBoldCircleOutline.vue'
import ArrowLeftCircleOutlineIcon from 'vue-material-design-icons/ArrowLeftCircleOutline.vue'
import ArrowRightBoldCircleOutlineIcon from 'vue-material-design-icons/ArrowRightBoldCircleOutline.vue'
import ArrowUpCircleOutlineIcon from 'vue-material-design-icons/ArrowUpCircleOutline.vue'
import CalendarIcon from 'vue-material-design-icons/Calendar.vue'
import CallSplitIcon from 'vue-material-design-icons/CallSplit.vue'
import CancelIcon from 'vue-material-design-icons/Cancel.vue'
import CartIcon from 'vue-material-design-icons/Cart.vue'
import ChartBarIcon from 'vue-material-design-icons/ChartBar.vue'
import CheckCircleIcon from 'vue-material-design-icons/CheckCircle.vue'
import CheckDecagramIcon from 'vue-material-design-icons/CheckDecagram.vue'
import ChevronDoubleDownIcon from 'vue-material-design-icons/ChevronDoubleDown.vue'
import ChevronDoubleLeftIcon from 'vue-material-design-icons/ChevronDoubleLeft.vue'
import ChevronDoubleRightIcon from 'vue-material-design-icons/ChevronDoubleRight.vue'
import ChevronDoubleUpIcon from 'vue-material-design-icons/ChevronDoubleUp.vue'
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue'
import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft.vue'
import ChevronRightCircleOutlineIcon from 'vue-material-design-icons/ChevronRightCircleOutline.vue'
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'
import ChevronUpIcon from 'vue-material-design-icons/ChevronUp.vue'
import ClipboardMultipleOutlineIcon from 'vue-material-design-icons/ClipboardMultipleOutline.vue'
import ClockAlertOutlineIcon from 'vue-material-design-icons/ClockAlertOutline.vue'
import CloseCircleIcon from 'vue-material-design-icons/CloseCircle.vue'
import CloseCircleOutlineIcon from 'vue-material-design-icons/CloseCircleOutline.vue'
import CogIcon from 'vue-material-design-icons/Cog.vue'
import CommentQuestionIcon from 'vue-material-design-icons/CommentQuestion.vue'
import CurrencyUsdIcon from 'vue-material-design-icons/CurrencyUsd.vue'
import DecagramIcon from 'vue-material-design-icons/Decagram.vue'
import DeleteIcon from 'vue-material-design-icons/Delete.vue'
import DownloadIcon from 'vue-material-design-icons/Download.vue'
import EmailIcon from 'vue-material-design-icons/Email.vue'
import ExitRunIcon from 'vue-material-design-icons/ExitRun.vue'
import FileDocumentIcon from 'vue-material-design-icons/FileDocument.vue'
import FileExcelIcon from 'vue-material-design-icons/FileExcel.vue'
import FileExportIcon from 'vue-material-design-icons/FileExport.vue'
import TableArrowLeftIcon from 'vue-material-design-icons/TableArrowLeft.vue'
import FileIcon from 'vue-material-design-icons/File.vue'
import FileOutlineIcon from 'vue-material-design-icons/FileOutline.vue'
import FileImageIcon from 'vue-material-design-icons/FileImage.vue'
import FilePowerpointIcon from 'vue-material-design-icons/FilePowerpoint.vue'
import FileWordIcon from 'vue-material-design-icons/FileWord.vue'
import FlagIcon from 'vue-material-design-icons/Flag.vue'
import FolderOpenIcon from 'vue-material-design-icons/FolderOpen.vue'
import FolderPlusIcon from 'vue-material-design-icons/FolderPlus.vue'
import HelpCircleIcon from 'vue-material-design-icons/HelpCircle.vue'
import ImageIcon from 'vue-material-design-icons/Image.vue'
import LayersIcon from 'vue-material-design-icons/Layers.vue'
import LinkIcon from 'vue-material-design-icons/Link.vue'
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue'
import MergeIcon from 'vue-material-design-icons/Merge.vue'
import MinusCircleIcon from 'vue-material-design-icons/MinusCircle.vue'
import OpenInNewIcon from 'vue-material-design-icons/OpenInNew.vue'
import PackageDownIcon from 'vue-material-design-icons/PackageDown.vue'
import PackageVariantIcon from 'vue-material-design-icons/PackageVariant.vue'
import PlusCircleIcon from 'vue-material-design-icons/PlusCircle.vue'
import RedoIcon from 'vue-material-design-icons/Redo.vue'
import RefreshIcon from 'vue-material-design-icons/Refresh.vue'
import ScaleBalanceIcon from 'vue-material-design-icons/ScaleBalance.vue'
import SleepIcon from 'vue-material-design-icons/Sleep.vue'
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue'
import StoreIcon from 'vue-material-design-icons/Store.vue'
import SwapHorizontalIcon from 'vue-material-design-icons/SwapHorizontal.vue'
import TruckIcon from 'vue-material-design-icons/Truck.vue'
import ThumbDown from 'vue-material-design-icons/ThumbDown.vue'
import ThumbDownOutline from 'vue-material-design-icons/ThumbDownOutline.vue'
import ThumbUp from 'vue-material-design-icons/ThumbUp.vue'
import ThumbUpOutline from 'vue-material-design-icons/ThumbUpOutline.vue'
import UndoIcon from 'vue-material-design-icons/Undo.vue'
import WebIcon from 'vue-material-design-icons/Web.vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('account-circle-icon', AccountCircleIcon)
  nuxtApp.vueApp.component('alert-circle-outline-icon', AlertCircleOutlineIcon)
  nuxtApp.vueApp.component('alert-decagram-icon', AlertDecagramIcon)
  nuxtApp.vueApp.component('alert-icon', AlertIcon)
  nuxtApp.vueApp.component('arrow-collapse-down-icon', ArrowCollapseDownIcon)
  nuxtApp.vueApp.component('arrow-left-bold-circle-outline-icon', ArrowLeftBoldCircleOutlineIcon)
  nuxtApp.vueApp.component('arrow-left-circle-outline-icon', ArrowLeftCircleOutlineIcon)
  nuxtApp.vueApp.component('arrow-right-bold-circle-outline-icon', ArrowRightBoldCircleOutlineIcon)
  nuxtApp.vueApp.component('arrow-up-circle-outline-icon', ArrowUpCircleOutlineIcon)
  nuxtApp.vueApp.component('calendar-icon', CalendarIcon)
  nuxtApp.vueApp.component('call-split-icon', CallSplitIcon)
  nuxtApp.vueApp.component('cancel-icon', CancelIcon)
  nuxtApp.vueApp.component('cart-icon', CartIcon)
  nuxtApp.vueApp.component('chart-bar-icon', ChartBarIcon)
  nuxtApp.vueApp.component('check-circle-icon', CheckCircleIcon)
  nuxtApp.vueApp.component('check-decagram-icon', CheckDecagramIcon)
  nuxtApp.vueApp.component('chevron-double-down-icon', ChevronDoubleDownIcon)
  nuxtApp.vueApp.component('chevron-double-left-icon', ChevronDoubleLeftIcon)
  nuxtApp.vueApp.component('chevron-double-right-icon', ChevronDoubleRightIcon)
  nuxtApp.vueApp.component('chevron-double-up-icon', ChevronDoubleUpIcon)
  nuxtApp.vueApp.component('chevron-down-icon', ChevronDownIcon)
  nuxtApp.vueApp.component('chevron-left-icon', ChevronLeftIcon)
  nuxtApp.vueApp.component('chevron-right-circle-outline-icon', ChevronRightCircleOutlineIcon)
  nuxtApp.vueApp.component('chevron-right-icon', ChevronRightIcon)
  nuxtApp.vueApp.component('chevron-up-icon', ChevronUpIcon)
  nuxtApp.vueApp.component('clipboard-multiple-outline-icon', ClipboardMultipleOutlineIcon)
  nuxtApp.vueApp.component('clock-alert-outline-icon', ClockAlertOutlineIcon)
  nuxtApp.vueApp.component('close-circle-icon', CloseCircleIcon)
  nuxtApp.vueApp.component('close-circle-outline-icon', CloseCircleOutlineIcon)
  nuxtApp.vueApp.component('cog-icon', CogIcon)
  nuxtApp.vueApp.component('comment-question-icon', CommentQuestionIcon)
  nuxtApp.vueApp.component('currency-usd-icon', CurrencyUsdIcon)
  nuxtApp.vueApp.component('decagram-icon', DecagramIcon)
  nuxtApp.vueApp.component('download-icon', DownloadIcon)
  nuxtApp.vueApp.component('email-icon', EmailIcon)
  nuxtApp.vueApp.component('exit-run-icon', ExitRunIcon)
  nuxtApp.vueApp.component('file-document-icon', FileDocumentIcon)
  nuxtApp.vueApp.component('file-excel-icon', FileExcelIcon)
  nuxtApp.vueApp.component('file-export-icon', FileExportIcon)
  nuxtApp.vueApp.component('table-arrow-left-icon', TableArrowLeftIcon)
  nuxtApp.vueApp.component('file-icon', FileIcon)
  nuxtApp.vueApp.component('file-outline-icon', FileOutlineIcon)
  nuxtApp.vueApp.component('file-image-icon', FileImageIcon)
  nuxtApp.vueApp.component('file-powerpoint-icon', FilePowerpointIcon)
  nuxtApp.vueApp.component('file-word-icon', FileWordIcon)
  nuxtApp.vueApp.component('flag-icon', FlagIcon)
  nuxtApp.vueApp.component('folder-open-icon', FolderOpenIcon)
  nuxtApp.vueApp.component('folder-plus-icon', FolderPlusIcon)
  nuxtApp.vueApp.component('help-circle-icon', HelpCircleIcon)
  nuxtApp.vueApp.component('image-icon', ImageIcon)
  nuxtApp.vueApp.component('layers-icon', LayersIcon)
  nuxtApp.vueApp.component('link-icon', LinkIcon)
  nuxtApp.vueApp.component('magnify-icon', MagnifyIcon)
  nuxtApp.vueApp.component('merge-icon', MergeIcon)
  nuxtApp.vueApp.component('minus-circle-icon', MinusCircleIcon)
  nuxtApp.vueApp.component('open-in-new-icon', OpenInNewIcon)
  nuxtApp.vueApp.component('package-down-icon', PackageDownIcon)
  nuxtApp.vueApp.component('package-variant-icon', PackageVariantIcon)
  nuxtApp.vueApp.component('plus-circle-icon', PlusCircleIcon)
  nuxtApp.vueApp.component('redo-icon', RedoIcon)
  nuxtApp.vueApp.component('refresh-icon', RefreshIcon)
  nuxtApp.vueApp.component('scale-balance-icon', ScaleBalanceIcon)
  nuxtApp.vueApp.component('sleep-icon', SleepIcon)
  nuxtApp.vueApp.component('square-edit-outline-icon', SquareEditOutlineIcon)
  nuxtApp.vueApp.component('swap-horizontal-icon', SwapHorizontalIcon)
  nuxtApp.vueApp.component('store-icon', StoreIcon)
  nuxtApp.vueApp.component('delete-icon', DeleteIcon)
  nuxtApp.vueApp.component('truck-icon', TruckIcon)
  nuxtApp.vueApp.component('undo-icon', UndoIcon)
  nuxtApp.vueApp.component('web-icon', WebIcon)
  nuxtApp.vueApp.component('thumb-down-icon', ThumbDown)
  nuxtApp.vueApp.component('thumb-down-outline-icon', ThumbDownOutline)
  nuxtApp.vueApp.component('thumb-up-icon', ThumbUp)
  nuxtApp.vueApp.component('thumb-up-outline-icon', ThumbUpOutline)
})
